import { startOfWeek, addDays, format } from 'date-fns';

export const getWeekRange = (
  date,
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 2
) => {
  // Get the start of the week (defaults to Tuesday-based, but can be customized)
  const start = startOfWeek(date, { weekStartsOn });
  const end = addDays(start, 6); // Ends 6 days after start

  // Convert to UTC: set start time to 00:00:00.000 and end time to 23:59:59.000
  const utcStart = new Date(
    Date.UTC(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0, 0)
  );
  const utcEnd = new Date(
    Date.UTC(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59, 0)
  );

  return {
    start: utcStart.toISOString(),
    end: utcEnd.toISOString(),
    formattedRange: `${format(utcStart, 'd MMM yyyy')} - ${format(end, 'd MMM yyyy')}`,
  };
};

const getLocalStorageKeyForWeek = (selectedProgram, selectedProduct) =>
  `weekFilter_${selectedProgram}_${selectedProduct}`;

export const saveSelectedWeekLocally = (
  selectedWeek,
  selectedProgram,
  selectedProduct
) => {
  const key = getLocalStorageKeyForWeek(selectedProgram, selectedProduct);
  localStorage.setItem(key, JSON.stringify(selectedWeek));
};

export const getSavedWeekFromLocalStorage = (
  selectedProgram,
  selectedProduct
) => {
  const key = getLocalStorageKeyForWeek(selectedProgram, selectedProduct);
  const storedWeek = localStorage.getItem(key);
  return storedWeek ? new Date(JSON.parse(storedWeek)) : null;
};

export const determineYearToUse = (selectedYear, minSelectableYear) => {
  if (minSelectableYear && minSelectableYear > selectedYear) {
    return minSelectableYear;
  }
  return selectedYear;
};

export const getEndOfMonth = (selectedDate) => {
  const year = selectedDate?.getFullYear();
  const month = selectedDate?.getMonth(); // Months are zero-indexed
  return new Date(Date.UTC(year, month + 1, 0, 23, 59, 59));
};

export const getCurrentDayOfMonth = () => {
  const currentDate = new Date();
  currentDate.setHours(23, 59, 59, 0); // Set the time to the end of the day
  return new Date(
    currentDate.getTime() - currentDate.getTimezoneOffset() * 60000
  );
};

export const getStartOfMonth = (selectedDate, flag = false) => {
  const year = selectedDate?.getFullYear();
  const month = selectedDate?.getMonth(); // Months are zero-indexed

  if (flag) {
    return new Date(year, month, 1);
  } else {
    const startDate = new Date(Date.UTC(year, month, 1));
    startDate.setUTCHours(0, 0, 0, 0);
    return startDate;
  }
};
